/**
 * Props for the DataTableV2ColumnSettingsTrigger component.
 * @public
 */
export interface DataTableV2ColumnSettingsTriggerProps {
  /** Custom label to be displayed in the column settings trigger. */
  children?: (params: {
    hiddenColumnCount: number;
    totalColumnCount: number;
    defaultLabel: string;
  }) => string;
}

/**
 * The slot component for specifying the custom label to be displayed in the column settings trigger
 * @public
 */
export const DataTableV2ColumnSettingsTrigger = ({
  children,
}: DataTableV2ColumnSettingsTriggerProps) => null;

DataTableV2ColumnSettingsTrigger.displayName =
  'DataTableV2.ColumnSettingsTrigger';
